import { PropData, Structure } from "bimatter-viewer/dist/Model/Model.types";
import { api } from "..";
import { store } from "../../store/store";

interface ElementInfo {
    id: number;
    modelID: number;
}
function getModelPath(modelID: number | string) {
    if (!!Number(modelID) || Number(modelID) === 0) {
        return (
            store
                .getState()
                .viewerMain.models[Number(modelID)]?.model_id.split(".min")[0] +
            "_props.json"
        );
    } else {
        return (modelID as string).split(".min")[0] + "_props.json";
    }
}
export const paramsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getParamsById: builder.mutation<PropData, ElementInfo>({
            query: (elementInfo) => {
                // const model_id =
                const model_id =
                    store
                        .getState()
                        .viewerMain.models[elementInfo.modelID]?.model_id.split(
                            ".min"
                        )[0] + "_props.json";

                // const model_id = "Clinic_Architectural_props.json";
                if (!model_id) return "/error";
                return {
                    url: `/params/getParamsById`,
                    method: "GET",
                    params: { model_id, element_id: elementInfo.id },
                };
            },
        }),
        getGuidDict: builder.mutation<
            { [id: string]: string },
            number | string
        >({
            query: (modelID: number | string) => {
                const model_id = getModelPath(modelID);
                if (!model_id) return "/error";
                return {
                    url: `/params/getGuidDict`,
                    method: "GET",
                    params: { model_id },
                };
            },
        }),
        getStructure: builder.mutation<
            Structure & { name: string },
            number | string
        >({
            query: (modelID: number | string) => {
                const model_id = getModelPath(modelID);
                if (!model_id) return "/error";
                return {
                    url: `/params/getStructure`,
                    method: "GET",
                    params: { model_id },
                };
            },
        }),
        compareProperties: builder.mutation<number[], number[] | string[]>({
            query: ([modelID_v1, modelID_v2]) => {
                const model_id_v1 = getModelPath(modelID_v1);
                const model_id_v2 = getModelPath(modelID_v2);
                if (!model_id_v1 || !model_id_v2) return "/error";
                return {
                    url: `/params/compareProperties`,
                    method: "GET",
                    params: { model_id_v1, model_id_v2 },
                };
            },
        }),
    }),
});

export const {
    useGetParamsByIdMutation,
    useGetStructureMutation,
    useGetGuidDictMutation,
    useComparePropertiesMutation,
} = paramsApi;
